/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type DomainOrganisationExportStatus = 'Pending' | 'Processing' | 'Completed' | 'Failed';

export const DomainOrganisationExportStatus = {
    Pending: 'Pending' as DomainOrganisationExportStatus,
    Processing: 'Processing' as DomainOrganisationExportStatus,
    Completed: 'Completed' as DomainOrganisationExportStatus,
    Failed: 'Failed' as DomainOrganisationExportStatus
};